import { HttpErrorResponse } from '@angular/common/http';
import { DEFAULT_ERROR_TEXT } from '../constants';

export const resolveHttpErrorMessage = (error: HttpErrorResponse): string => {
  const httpMessage = error.error?.message;
  if (error.status === 0 || !httpMessage) {
    return DEFAULT_ERROR_TEXT;
  }
  return httpMessage;
};
